<template>
  <vue-splitter
    :margin="30"
    :horizontal="horizontal"
    style="display: flex; height:  100%; overflow: hidden "
  >
    <group
      slot="left-pane"
      @choice="choice"
    />
    <group-config
      slot="right-pane"
      :group="cur_group"
    />
  </vue-splitter>
</template>

<script>
import GroupConfig from './SimCardDevicesGroupList/SimCardDevicesGroupConfig'
import Group from './SimCardDevicesGroupList/SimCardDevicesGroupList'
import VueSplitter from '@rmp135/vue-splitter'
export default {
  name: 'SimCardDevicesGroup',
  components: {
    GroupConfig,
    VueSplitter,
    Group
  },
  data () {
    return {
      new_group: '',
      cur_group: {}
    }
  },
  computed:{
    horizontal(){
      if (document.documentElement.clientWidth <= 768) {
        return true
      }
      return false
    }
  },
  methods: {
    choice (group) {
      this.cur_group = group
    }
  }
}
</script>
